"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bemIcon = exports.GlIcon = exports.GL_ICON_THEME = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _bero = _interopRequireWildcard(require("bero"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["onClick", "className", "iconClassName", "style", "name", "theme", "title"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var bemIcon = (0, _bero.default)('gl-icon');
exports.bemIcon = bemIcon;
var GL_ICON_THEME = {
  light: 'light'
};
exports.GL_ICON_THEME = GL_ICON_THEME;

var GlIconCore = function GlIconCore(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      iconClassName = _ref.iconClassName,
      style = _ref.style,
      name = _ref.name,
      theme = _ref.theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var getDynamicProps = function getDynamicProps(onClick) {
    return onClick && {
      onClick: onClick,
      onKeyPress: onClick,
      role: 'link',
      tabIndex: 0
    };
  };

  var titleParsed = name.replace(/^(.)|\s+(.)/g, function (a) {
    return a.toUpperCase();
  });
  var titleSvg = title || titleParsed.replace(/-/g, ' ');
  var dynamicProps = (0, _react.useMemo)(function () {
    return getDynamicProps(onClick);
  }, [onClick]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
    className: (0, _bero.join)(bemIcon('wrapper'), className)
  }, dynamicProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
      className: (0, _bero.join)(bemIcon({
        light: theme === GL_ICON_THEME.light
      }), iconClassName)
    }, props), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        xlinkHref: "#".concat(name)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
        children: titleSvg
      })]
    }))
  }));
};

var GlIcon = /*#__PURE__*/(0, _react.memo)(GlIconCore);
exports.GlIcon = GlIcon;